/*
 * Clog + strap bundles (Shopify Bundles): the "Huggees Straps - ... (Size)" option is
 * hidden and follows the "... Clogs - ... (Size)" option. The strap is the same size as
 * the clog; if that strap is out of stock, the next size up in stock, else the nearest
 * smaller one.
 *
 * Product pages: Swatch King draws the size buttons, so the chosen strap button is
 * clicked whenever the clog size changes. The strap group is hidden by CSS in
 * layout/theme.liquid.
 * Cart edit popup: theme radios, fieldsets marked by snippets/bundle-strap-option.liquid.
 */
(function () {
    var STRAP = '[option-name^="Huggees Straps"]';
    var CLOG = '[option-name*="Clogs"]';

    function sizeOrder(size) {
        return parseInt(size, 10) || 0;
    }

    // variants: product variants JSON; strapKey / clogKey: 'option1', 'option2'.
    function pickStrapSize(variants, strapKey, clogKey, clogSize, strapSizes) {
        var sizes = strapSizes.slice().sort(function (a, b) { return sizeOrder(a) - sizeOrder(b); });
        var target = sizeOrder(clogSize);
        var same = sizes.filter(function (s) { return sizeOrder(s) === target; });
        var larger = sizes.filter(function (s) { return sizeOrder(s) > target; });
        var smaller = sizes.filter(function (s) { return sizeOrder(s) < target; }).reverse();
        var candidates = same.concat(larger, smaller);

        for (var i = 0; i < candidates.length; i++) {
            for (var j = 0; j < variants.length; j++) {
                var v = variants[j];
                if (v[clogKey] === clogSize && v[strapKey] === candidates[i] && v.available) return candidates[i];
            }
        }
        // Nothing in stock: keep the closest size so the button shows sold out.
        return candidates[0];
    }

    function variantsIn(root) {
        var script = root && root.querySelector('variant-radios [type="application/json"], variant-edit-radios [type="application/json"]');
        if (!script) return null;
        try {
            return JSON.parse(script.textContent);
        } catch (e) {
            return null;
        }
    }

    // ---- Swatch King (product pages) ----

    var lastTried = new WeakMap();

    function syncSwatchKing() {
        document.querySelectorAll('variant-swatch-king').forEach(function (sk) {
            var strap = sk.querySelector(STRAP);
            var clog = sk.querySelector(CLOG);
            if (!strap || !clog) return;

            var selected = clog.querySelector('.swatch-selector.swatch-selected');
            var variants = variantsIn(sk.closest('.productView'));
            if (!selected || !variants) return;

            var strapSizes = Array.prototype.map.call(strap.querySelectorAll('.swatch-selector[data-value]'), function (b) {
                return b.getAttribute('data-value');
            });
            var size = pickStrapSize(variants, strap.getAttribute('option-target'), clog.getAttribute('option-target'),
                selected.getAttribute('data-value'), strapSizes);

            var current = strap.querySelector('.swatch-selector.swatch-selected');
            if (current && current.getAttribute('data-value') === size) {
                lastTried.delete(sk);
                return;
            }

            // Don't keep clicking a size Swatch King refuses to select.
            if (lastTried.get(sk) === size) return;
            var button = strap.querySelector('.swatch-selector[data-value="' + CSS.escape(size) + '"]');
            if (!button) return;
            lastTried.set(sk, size);
            button.click();
        });
    }

    var WATCHED = 'variant-swatch-king, .product-edit-item';
    var timer;
    function scheduleSync() {
        clearTimeout(timer);
        timer = setTimeout(function () {
            syncSwatchKing();
            document.querySelectorAll('variant-edit-radios').forEach(function (picker) {
                if (picker.querySelector('[data-bundle-strap]')) afterChange(picker);
            });
        }, 30);
    }

    new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
            var node = mutations[i].target;
            if (node.closest && node.closest(WATCHED)) return scheduleSync();
            if (node.querySelector && node.querySelector(WATCHED)) return scheduleSync();
        }
    }).observe(document.documentElement, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class']
    });
    scheduleSync();

    // ---- Theme radios (cart edit popup) ----

    function optionKey(fieldset) {
        return 'option' + (parseInt(fieldset.getAttribute('data-option-index'), 10) + 1);
    }

    function syncStrap(picker) {
        var clogSet = picker.querySelector('[data-bundle-clog]');
        var strapSet = picker.querySelector('[data-bundle-strap]');
        var clog = clogSet && clogSet.querySelector('input[type="radio"]:checked');
        var variants = variantsIn(picker.parentElement);
        if (!clog || !strapSet || !variants) return;

        var straps = strapSet.querySelectorAll('input[type="radio"]');
        var size = pickStrapSize(variants, optionKey(strapSet), optionKey(clogSet), clog.value,
            Array.prototype.map.call(straps, function (input) { return input.value; }));
        for (var i = 0; i < straps.length; i++) {
            if (straps[i].value === size) straps[i].checked = true;
        }
    }

    // The theme marks sizes sold out against the selected strap; restore each clog
    // size's own stock, and show only the clog size in the title.
    function afterChange(picker) {
        picker.querySelectorAll('[data-bundle-clog] [data-bundle-stock]').forEach(function (label) {
            var available = label.getAttribute('data-bundle-stock') === 'available';
            label.classList.toggle('available', available);
            label.classList.toggle('soldout', !available);
            if (label.classList.contains('unavailable')) label.classList.remove('unavailable');
        });

        var clog = picker.querySelector('[data-bundle-clog] input[type="radio"]:checked');
        var item = picker.closest('.product-edit-item');
        var title = clog && item && item.querySelector('[data-change-title]');
        if (title && title.textContent !== clog.value) title.textContent = clog.value;
    }

    // Capture phase: runs before the theme's change handler reads the selected options.
    document.addEventListener('change', function (event) {
        var target = event.target;
        if (!target.closest || !target.closest('[data-bundle-clog]')) return;
        var picker = target.closest('variant-edit-radios');
        if (picker) syncStrap(picker);
    }, true);

    // Bubble phase: runs after the theme has updated the option labels.
    document.addEventListener('change', function (event) {
        var picker = event.target.closest && event.target.closest('variant-edit-radios');
        if (picker && picker.querySelector('[data-bundle-strap]')) afterChange(picker);
    });
})();
